/* src/app/components/leads/upload-docs/upload-docs.component.css */
/*# sourceMappingURL=upload-docs.component-YNF73XE3.css.map */
